import {Button, Paper} from "@mui/material";
import CurrencyFormatter from "../../../../../components/CurrencyFormatter/CurrencyFormatter";
import React from "react";
import {ButtonProps} from "@mui/material/Button/Button";
import Bancontact from "../../../../../components/Icons/Bancontact";
import Visa from "../../../../../components/Icons/Visa";
import Mastercard from "../../../../../components/Icons/Mastercard";
import { PaymentMethod } from "../../../../../gql/graphql";
import Paysafecard from "../../../../../components/Icons/Paysafecard";

interface Props {
    currentMethod: PaymentMethod | null;
    paymentMethod: PaymentMethod | null;
    fn: (method:PaymentMethod)=> void;
    children?: React.ReactNode;
}

export const paymentMethodIcon = (value : string, small?: boolean) => {
    let width= '100px';
    let height = '85px';
    let widthMobile= '80px';
    let heightMobile = '68px';
    if(small) {
        width = '40px';
        height = '32px';
        widthMobile= '40px';
        heightMobile = '32px';
    }
    {switch (value) {
        case 'Bancontact':
            return (
                <Bancontact sx={{width: {xs:widthMobile,md:width}, height: {xs:heightMobile,md:height}}}/>
            );
            break;
        case 'Bancontact-QR':
            return (
                <Bancontact sx={{width: {xs:widthMobile,md:width}, height: {xs:heightMobile,md:height}}}/>
            );
            break;
        case 'Visa':
            return (
                <Visa sx={{width: {xs:widthMobile,md:width}, height: {xs:heightMobile,md:height}, pt: "0px"}}/>
            )
            break;
        case 'Mastercard':
            return (
                <Mastercard sx={{width: {xs:widthMobile,md:width}, height: {xs:heightMobile,md:height}, pt: "0px"}}/>
            );
            break;
        case 'Paysafecard':
            return (
                <Paysafecard sx={{width: {xs:widthMobile,md:width}, height: {xs:heightMobile,md:height}, pt: "0px"}}/>
            );
            break;
        default:
            break;
    }
    }
}

export const PaymentMethodComponent: React.FC<Props> = (props) => {
    const {paymentMethod, currentMethod,fn, children, ...restProps} = props;
    
   
    
    return (
        <>{paymentMethodIcon(paymentMethod?.paymentProduct.name as string) && (
        <Paper sx={{cursor:'pointer',border: currentMethod?.paymentProduct.id ==paymentMethod?.paymentProduct.id && currentMethod?.paymentProvider.id == paymentMethod?.paymentProvider.id ? (theme)=> `1px solid ${theme.palette.primary.main}`:'1px solid transparent',px: 1, height: {xs:"64px",md:"80px"}}} 
               
                     onClick={() => fn(paymentMethod as PaymentMethod)} {...restProps}>
            {paymentMethodIcon(paymentMethod?.paymentProduct.name as string)}
    </Paper>)}</>);
        
}